<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg"
            :doctorId="doctorId"></DocMsg>
    <div class="page_title flex_between">
      <span>客服处理记录</span>
      <el-button type="primary"
                 style="width: 92px"
                 size="medium"
                 @click="back">返回</el-button>
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="title">处方及订单信息</div>
        <div class="infobox">
          <div style="display: flex;margin-bottom:16px">
            <div style="width: 260px">
              <span>订单编号：</span>
              <span>{{ detail.order_sn }}</span>
            </div>
            <div style="width: 260px">
              <span>处方号：</span>
              <span>{{ detail.pre_id }}</span>
            </div>
          </div>
          <div style="display: flex">
            <div style="width: 260px">
              <span>患者姓名：</span>
              <span style="color: #666">{{ detail.user_name }}</span>
            </div>
            <div style="width: 260px">
              <span>医生姓名：</span>
              <span style="color: #666;cursor:pointer"
                    @click="showDocMsg(detail.doctor_id)">{{ detail.doctor_name }}</span>
            </div>
            <div style="width: 260px">
              <span>药房：</span>
              <span style="color: #666">{{ detail.hospital_name }}</span>
            </div>
          </div>
        </div>
        <div>
          <el-button type="primary"
                     size="medium"
                     @click="addLogDia"
                     :disabled="
              module_id_array[0] ? !module_id_array.includes('1042') : false
            ">添加处理记录</el-button>
        </div>
        <div style="margin-top:30px">
          <el-timeline>
            <el-timeline-item v-for="(item, index) in order_log_info"
                              :key="index"
                              :type="item.type"
                              :color="item.color"
                              :size="item.size">
              <div>
                <div style="color:#999;margin-bottom:10px">
                  <span style="margin-right:20px">
                    {{item.action_name}}
                  </span>
                  <span>
                    {{item.create_time}}
                  </span>
                </div>
                <div>
                  <span>处理问题类型：</span>
                  {{ item.action_type }}
                </div>
                <div style="margin:6px 0">
                  <span>已处理事项：</span>
                  {{ item.action_yes?item.action_yes:"----" }}
                </div>
                <div>
                  <span>待处理事项：</span>
                  {{ item.action_no?item.action_no:"----"}}
                </div>
              </div>

            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </div>
    <!-- 添加处理记录 -->
    <el-dialog title="添加处理记录"
               :visible.sync="logDia"
               width="500px"
               style="text-align: left"
               :close-on-click-modal="false">
      <div>
        <div style="padding-top:20px;text-align:left">
          <el-form :model="ruleForm"
                   :rules="rules"
                   ref="ruleForm"
                   label-width="140px"
                   class="demo-ruleForm">
            <el-form-item label="处理问题类型"
                          prop="action_type">
              <el-select v-model="ruleForm.action_type"
                         placeholder="请选择"
                         style="width: 300px">
                <el-option v-for="item in queList"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="已处理事项"
                          prop="action_yes"
                          style="margin-bottom:120px">
              <el-input type="textarea"
                        :rows="6"
                        maxlength="500"
                        show-word-limit
                        v-model="ruleForm.action_yes"
                        style="width: 300px"
                        resize="none"></el-input>
            </el-form-item>
            <el-form-item label="未处理事项"
                          prop="action_no">
              <el-input type="textarea"
                        :rows="6"
                        maxlength="500"
                        show-word-limit
                        v-model="ruleForm.action_no"
                        style="width: 300px"
                        resize="none"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center; padding-bottom: 20px;margin-top:120px">
          <span slot="footer"
                class="dialog-footer">
            <el-button plain
                       @click="logDia = false"
                       style="width: 92px"
                       size="medium">关闭</el-button>
            <el-button type="primary"
                       @click="submit('ruleForm')"
                       style="width: 92px"
                       size="medium">保存</el-button>
          </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import DocMsg from '../../../components/common/DocMsg.vue';
import dayjs from 'dayjs';
export default {
  name: 'orderDetail',
  data() {
    return {
      order_log_info: [],
      queList: [
        {
          value: '咨询指导',
          label: '咨询指导'
        },
        {
          value: '处方指导',
          label: '处方指导'
        },
        {
          value: '物流问题',
          label: '物流问题'
        },
        {
          value: '药品答疑',
          label: '药品答疑'
        },
        {
          value: '功能建议',
          label: '功能建议'
        },
        {
          value: '其他问题',
          label: '其他问题'
        }
      ],
      detail: {},
      logDia: false,
      ruleForm: {
        pre_id: this.$route.query.pre_id,
        order_id: 0,
        action_type: '',
        action_yes: '',
        action_no: ''
      },
      rules: {
        action_type: [
          { required: true, message: '请选择问题类型', trigger: 'blur' }
        ]
      },
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取详情
    getDetail() {
      let pre_id = this.$route.query.pre_id;
      this.axios.post('platform/order/getOrderLog', { pre_id }).then((res) => {
        if (res.code == 0) {
          this.detail = res.data.order_info;
          if (res.data.order_log_info.length) {
            this.order_log_info = res.data.order_log_info.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format('YYYY-MM-DD HH:mm');
              return item;
            });
            this.order_log_info[0].type = 'primary';
            this.order_log_info[0].size = 'large';
          }
        }
      });
    },
    //返回
    back() {
      history.back();
    },
    //添加记录弹窗
    addLogDia() {
      this.ruleForm = {
        pre_id: this.$route.query.pre_id,
        order_id: 0,
        action_type: '',
        action_yes: '',
        action_no: ''
      };
      this.logDia = true;
    },
    //添加反馈处理
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.action_yes && !this.ruleForm.action_no) {
            this.$message.error('请填写已处理事项或未处理事项');
            return false;
          }
          let data = this.ruleForm;
          this.axios.post('platform/order/addOrderLog', data).then((res) => {
            if (res.code == 0) {
              this.$message.success('保存成功！');
              this.logDia = false;
              this.getDetail();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 140px);
  padding: 20px;
  box-sizing: border-box;
  text-align: left;
  background: #fff;
}

.title {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 12px;
}

.infobox {
  text-align: left;
  border: solid 1px #cfcece;
  padding: 20px;
  margin-bottom: 20px;
  color: #747981;
}

.dialog {
  padding: 0 15px 15px;
  text-align: left;
}
.pricebox {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  .priceitem {
    width: 200px;
    line-height: 24px;
  }
}
</style>